import React from 'react';
import styled from 'styled-components';
import {
    Modal,
    palette,
    spacing,
    ColorMode,
    Heading,
    fontSize,
} from '@landr/maestro';

export const Wrapper = styled(Modal.Section)`
    padding: ${spacing('mg')};
    overflow: hidden;
    position: relative;
    width: 50%;

    background: linear-gradient(
        180deg,
        ${palette('platinum.900')} 0%,
        ${palette('platinum.1000')} 100%
    );

    ${({ theme }): string => theme.breakpoint('lg')`
        padding: ${spacing('xxl')};
    `};

    ${Heading} {
        font-size: ${fontSize('xxxl')};
        line-height: 1.1;

        ${({ theme }): string => theme.breakpoint('lg')`      
            font-size: ${fontSize('xl')}
        `};
    }

    ${({ theme }): string => theme.breakpoint('md')`
         width: 100%;
    `}
`;

export const Header = styled(Modal.Header)`
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background: none;

    ${({ theme }): string => theme.breakpoint('md')`
        display: block;
        z-index: 2;
    `};
`;

export const Content = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    position: relative;
    text-align: center;
    width: 100%;
    z-index: 1;
`;

const DescriptiveSection: React.FC = ({ children }) => (
    <ColorMode mode="invert">
        <Wrapper>
            <Header />
            <Content>{children}</Content>
        </Wrapper>
    </ColorMode>
);

export default DescriptiveSection;
